import React from "react";
import "./MicroplateReadout1.scss";
import { MicroplateReadoutProps } from "../types";

export const MicroplateReadout1 = (props: MicroplateReadoutProps) => {
  const columns = ["1", "2", "3"];
  const rows = ["A", "B", "C", "D", "E", "F", "G"];

  return (
    <div className="microplate-readout-container">
      <div className="full-grid">
        <div className="left-column">
          <div className="side-label header" />
          {rows.map((row) => (
            <div key={row} className="side-label">
              {typeof props.wellsColors[row]?.description === "object"
                ? JSON.stringify(props.wellsColors[row]?.description)
                : (props.wellsColors[row]?.description ?? "-")}
            </div>
          ))}
        </div>

        <div className="grid-container1">
          <div className="grid-header">
            <div className="grid-cell header-cell"></div>
            {columns.map((col) => (
              <div key={col} className="grid-cell header-cell">
                {col}
              </div>
            ))}
          </div>
          <div className="grid-body">
            {rows.map((row) => (
              <div key={row} className="grid-row">
                <div className="grid-cell row-header">{row}</div>
                {columns.map((col) => {
                  const cell = props.wellsColors[row]?.[col];
                  const value =
                    typeof cell === "object" && cell !== null && "value" in cell
                      ? cell.value.toFixed(3)
                      : "0.000";
                  const color = props.wellsColors[row]?.color || "none";
                  return (
                    <div
                      key={`${row}-${col}`}
                      className="grid-cell"
                      style={{ backgroundColor: color }}
                    >
                      {value}
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
        </div>

        <div className="right-column">
          <div className="side-label header">Average</div>
          {rows.map((row) => (
            <div key={row} className="side-label">
              {typeof props.wellsColors[row]?.average === "object" &&
              props.wellsColors[row]?.average !== null &&
              typeof props.wellsColors[row]?.average === "object" &&
              "value" in
                (props.wellsColors[row]?.average as unknown as Record<string, unknown>)
                ? (
                    props.wellsColors[row]?.average as unknown as {
                      value: number;
                    }
                  ).value
                : (props.wellsColors[row]?.average ?? "0.000")}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
